<div>
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <button mat-button (click)="onRefresh()">
        <mat-icon aria-hidden="false" aria-label="Refresh">refresh</mat-icon>
        Refresh Users
      </button>
      <button mat-button (click)="onAdd()">
        <mat-icon aria-hidden="false" aria-label="Add User">add</mat-icon>
        Add User
      </button>
      <span class="toolbar-spacer"></span>
      <mat-form-field color="accent">
        <input matInput placeholder="Search users..." [(ngModel)]="filter" (ngModelChange)="onFilter($event)" />
      </mat-form-field>
      <button mat-icon-button aria-label="Clear" *ngIf="filter" (click)="onFilter('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <ng-container *ngIf="loading; else loaded">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading Users...</p>
    </div>
  </ng-container>
  <ng-template #loaded>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort width="100%">
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
        <td mat-cell *matCellDef="let item">{{ item.username }}</td>
      </ng-container>
      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let item">{{ item.fullName }}</td>
      </ng-container>
      <ng-container matColumnDef="sapId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sap ID</th>
        <td mat-cell *matCellDef="let item">{{ item.sapId }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-flat-button color="accent" [routerLink]="['/admin/users', item.username]">Edit</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </ng-template>
</div>
